import React, { useEffect, useState } from "react";
import styles from "./pages.module.css";

import { useMediaUpdate } from "../contexts/MediaContext";
import { getMediaByID } from "../api/Api"

import { useParams } from "react-router-dom";
import { Footer } from "../comonents/Footer/Footer";
import { MediaBanner } from "../comonents/Banners/MediaBanner";
import { useUpdateNavigationContext } from "../contexts/NavagationContext";
import ErrorHandler from "../helpers/ErrorHandler";

export default function Book() {

    // ----------------------------------------------------- STATE AND HOOKS=
    const mediaid = useParams().bookID;
    let token = localStorage.getItem("token");

    const mediaUpdater = useMediaUpdate();

    const setCurrentLocation = useUpdateNavigationContext();
    setCurrentLocation("media")

    const [badBook, setBadBook] = useState(false);

    useEffect(() => {
        mediaUpdater({}) // reset media to avoid flash of previous
        fetchBook();
        setBadBook(false);
        
    }, [mediaid]);

    async function fetchBook() {
        // gets book
        // determining access level
        let tokenPeices = token.split(".");
        let idAndRole = atob(tokenPeices[1]);
        let role = idAndRole.split(",")[1];

        await getMediaByID(mediaid, token)
            .then((foundBook) => {
                mediaUpdater(foundBook);
            })
            .catch((error) => {
                console.log("failed to get usermedia", error);
                ErrorHandler(error);
            });
    }

    // ----------------------------------------------------- RENDER
    if (badBook) {
        return (
            <div className={styles.container}>
                <div className={styles.errorMessage}>
                    This shelf is empty
                </div>
            </div>
        )
    } else {
        return (
            <div className={styles.container}>
                <div className={styles.content}>
                    <MediaBanner />
                </div>
                <Footer />
            </div>
        );
    }
}